import EditIntegrationModal from './EditIntegrationModal';

import './EditIntegrationModal.scss';

export default EditIntegrationModal;
